import { BorrowerNaturalPersonDto } from 'api/borrower';
import { ReferentialKey } from 'api/referential';
import { ReferentialDto } from 'api/risk';
import {
  BorrowerInsuredFormFieldNames,
  BorrowerNaturalFormValues
} from 'features/subscription-process/profiling-process/forms/borrower-insured';
import { mapNaturalPersonFormValues } from './mapNaturalPersonFormValues';

export function mapBorrowerNaturalPersonFormValues(
  values: BorrowerNaturalFormValues,
  referentialsData: Record<ReferentialKey, ReferentialDto[]>,
): BorrowerNaturalPersonDto {

  const { job, prospectType, ...naturalPersonFormValues } = values

  const findReferentialId = (referentialType: ReferentialKey, code: string): string => {
    const item = referentialsData[referentialType]?.find((item: any) => item.code === code);
    return item?.id || '';
  };

  const mappedNaturalPersonValues = mapNaturalPersonFormValues(naturalPersonFormValues, referentialsData)

  return {
    ...mappedNaturalPersonValues,
    job,
    prospectTypeId: findReferentialId(ReferentialKey.ProspectType, prospectType),
    borrowerId: values[BorrowerInsuredFormFieldNames.BorrowerId],
  };
}
